import { render, staticRenderFns } from "./series-table.vue?vue&type=template&id=00183bdd&scoped=true&"
import script from "./series-table.vue?vue&type=script&lang=ts&"
export * from "./series-table.vue?vue&type=script&lang=ts&"
import style0 from "./series-table.vue?vue&type=style&index=0&id=00183bdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00183bdd",
  null
  
)

export default component.exports